<template>
  <normal-layout
      :title="'钱包明细'"
      :content-background-color="'#F0F0F4'"
      :show-bottom-border="true"
  >
    <template #left-btn>
      <left-button/>
    </template>
    <template #content>
      <div class="p-container">
        <pull-refresh v-if="!isEmpty" v-model="refreshing" @refresh="onRefresh" style="min-height: 100vh">
          <list v-model="isLoading"
                :finished="finished"
                finished-text="没有更多了"
                :error.sync="error"
                error-text="请求失败，点击重新加载"
                @load="onLoad">
            <div v-for="(item,index) in list" :key="index" class="pc-item" @click="goDetail(item)">
              <div class="pci-content">
                <div class="pcc-left">
                  <div class="pcl-left">
                    <p>{{ getTitle(item) }}</p>
                    <label>{{ item.transactionDatetime || '' }}</label>
                  </div>
                  <div class="pcl-right">
                    <p>{{ item.transactionAmount || 0 }}</p>
                    <span v-if="showContent" :style="{color: contentColor}">{{ getContent(item) }}</span>
                  </div>
                </div>
                <img src="../../assets/images/wallet/more.png" alt/>
              </div>
              <div class="pci-divider"></div>
            </div>
          </list>
        </pull-refresh>
        <empty-view v-else :message="'暂无资金明细'" :icon="emptyIcon"/>
      </div>
    </template>
  </normal-layout>
</template>

<script>
import NormalLayout from '../../components/actionbar/BasicLayout'
import LeftButton from '../../components/actionbar/TopLeftButton'
import { PullRefresh, List, Toast } from 'vant'
import { getParticularsList } from '@/request/api.encryptor'
import EmptyView from './components/EmptyView'
import EmptyIcon from '../../assets/images/wallet/empty.svg'

export default {
  name: 'Particulars',
  components: {
    NormalLayout,
    LeftButton,
    PullRefresh,
    List,
    EmptyView
  },
  data() {
    return {
      refreshing: false,
      isLoading: false,
      finished: false,
      error: false,
      isEmpty: false,
      emptyIcon: EmptyIcon,
      showContent: true,
      page: 1,
      pageSize: 20,
      list: [],
      contentColor: '#C2C2C2'
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getList()
    })
  },
  methods: {
    goDetail(item) {
      const { id = 0 } = item || {}
      this.$JD.nativeRouter({
        url: '/wallet/particularsDetail',
        query: {
          id
        }
      })
    },
    onRefresh() {
      this.page = 1
      this.getList()
    },
    onLoad() {
      this.getList()
    },
    // 获取数据
    getList() {
      const params = {
        balanceType: '0', // 钱包明细类型：0-余额，1-通宝 ,
        pageNo: this.page,
        pageSize: this.pageSize,
        type: '00'
      }
      getParticularsList(params)
          .then(res => {
            this.refreshing = false
            this.isLoading = false
            const { code = 1, msg = '', info = [] } = res || {}
            if (code !== 0) {
              this.error = this.page !== 1
              Toast(msg)
              return
            }
            // 无数据
            if (this.page === 1 && info.length === 0) {
              this.isEmpty = true
              return
            }
            this.finished = info.length === 0
            if (this.page === 1) {
              this.list = info
            } else {
              this.list = this.list.concat(info)
            }
            this.page++
          })
          .catch(error => {
            this.refreshing = false
            this.isLoading = false
            this.error = this.page !== 1
            Toast(error)
          })
    },
    getContent(item) {
      const { transactionType = '0', status = '0' } = item || {}
      if (transactionType === '3' && status === '0') {
        this.showContent = true
        this.contentColor = '#C2C2C2'
        return '提现成功'
      }
      if (transactionType === '3' && status === '1') {
        this.showContent = true
        this.contentColor = '#41BD76'
        return '提现失败'
      }
      this.showContent = false
      return ''

    },
    getTitle(item) {
      const { transactionType = '0' } = item || {}
      switch (transactionType) {
        case '0':
          return '退款金额'
        case '1':
          return '转账金额'
        case '2':
          return '支付金额'
        case '3':
          return '提现金额'
        case '4':
          return '收益转账'
        default:
          return '消费金额'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.p-container {
  width: 100%;
  height: 100%;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;

  .pc-item {
    display: flex;
    flex-direction: column;
    background-color: white;

    .pci-content {
      display: flex;
      flex-direction: row;
      padding: 0.253rem 0.133rem;
      align-items: center;

      .pcc-left {
        flex: 1;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        div {
          display: flex;
          flex-direction: column;

          p {
            color: #525252;
            font-size: .2rem;
          }

          span {
            color: #C2C2C2;
            font-size: .16rem;
            margin-top: .107rem;
          }

          label {
            color: #C2C2C2;
            font-size: .16rem;
            margin-top: .107rem;
          }
        }

        .pcl-left {
          align-items: start;
        }

        .pcl-right {
          align-items: flex-end;
        }
      }

      img {
        width: .1rem;
        height: .18rem;
        margin-left: .16rem;
      }

    }

    .pci-divider {
      background-color: #F0F0F4;
      height: .5px;
    }
  }
}
</style>
